import { LOGIN_USER, LOGOUT_USER, USER_ERROR } from ".";
import { setLoading } from "./recipeActions";
import { axiosWithAuth } from "../Helpers/AxiosWithAuth";

export const login = (creds) => async (dispatch) => {
	dispatch(setLoading());

	try {
		const response = await axiosWithAuth().post(`/api/auth/login`, creds);
		const statusCode = response.status;

		if (statusCode === 200) {
			console.log("login Successful");
			localStorage.setItem("token", response.data.token);
			dispatch({ type: LOGIN_USER, payload: response.data });
		} else {
			console.debug("Login Failed -->", statusCode);
		}
	} catch (err) {
		console.debug("Login Failed -->", err);
	}

	return;
};

export const createUser = (creds) => (dispatch) => {
	setLoading();
	axiosWithAuth()
		.post(`/api/auth/register`, creds)
		.then((res) => {
			console.log(res);
		})
		.catch((err) => dispatch({ type: USER_ERROR, payload: err.message }));
};

export const logout = () => async (dispatch) => {
	setLoading();
	axiosWithAuth()
		.get(`https://secret-recipes-4.herokuapp.com/api/auth/logout`)
		.then((res) => dispatch({ type: LOGOUT_USER, payload: res.data }))
		.catch((err) => dispatch({ type: USER_ERROR, payload: err.message }));
};
